var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_vm._l((_vm.widget.data.contents),function(content){return [_c('span',{staticStyle:{"width":"100%","float":"right"},domProps:{"innerHTML":_vm._s(content)}})]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }